import React from 'react';
import { Redirect, RouteComponentProps } from 'react-router';
import { withRouter } from 'react-router-dom';

const RedirectToDomainScreen = withRouter(({ location }: RouteComponentProps) =>
  <Redirect to={{ pathname: '/domain', search: `?redirect=${location.pathname}` }} />
);

export default RedirectToDomainScreen;
